import { formatCurrency } from '../../../../../features/passport/formatCurrency';

/**
 * Takes a string number and converts it to a formatted currency string using Intl.NumberFormat.
 *
 * If the formatted value contains "NaN", an empty string is returned.
 */
export const convertToFormattedCurrencyString = (value, currencyCode, locale) => {
  // Discover the locale's grouping and decimal symbols.
  const testNumber = Intl.NumberFormat(locale, {
    style: 'decimal'
  }).formatToParts(1000.01);
  const groupingSymbol = testNumber.find(part => part.type === 'group')?.value || '';
  const decimalSymbol = testNumber.find(part => part.type === 'decimal')?.value || '';

  /**
   * To ensure the string is accurately converted to a number:
   * - Remove commas, otherwise NaN.
   * - For locales that use a comma as the decimal separator, convert it to a period, otherwise NaN.
   */
  let cleanedValue = value.replaceAll(groupingSymbol, '');
  if (decimalSymbol === ',') {
    cleanedValue = cleanedValue.replace(',', '.');
  }
  if (cleanedValue === '') return '';

  // Format as currency without the currency symbol
  const formattedValue = formatCurrency({
    locale,
    currencyCode,
    amount: cleanedValue,
    options: {
      currencyDisplay: 'code',
      trailingZeroDisplay: 'stripIfInteger'
    }
  }).replace(currencyCode, '').trim();

  // We never want NaN shown to the user, so return an empty string instead
  if (formattedValue.includes('NaN')) return '';
  return formattedValue;
};